// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamento_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/formas_pagamento/lista
 *
 * Lists payment methods. Sem corpo: o catálogo global. Com franquia_id: cada forma como vale
 * naquela franquia (chamado 2026-0023).
 */
import { registerContract } from './validate'

export interface FormasPagamento_ListaInput {
franquia_id?: number
}

registerContract('FormasPagamento_ListaInput', {
  franquia_id: { type: 'number',  required: false },
})
